const toneBg = {
  candy: "bg-candy text-white",
  pink: "bg-pink text-ink",
  yellow: "bg-yellow text-ink",
  mint: "bg-mint text-ink",
  ink: "bg-ink text-white",
  paper: "bg-white text-ink",
};

/** FloatingIcon — icon in a colored circular container with border + shadow */
export const FloatingIcon = ({
  icon: Icon,
  tone = "candy",
  size = 44,
  shape = "circle", // circle | square | blob
  rotate = 0,
  className = "",
  wiggle = true,
  strokeWidth = 2.5,
  ...rest
}) => {
  const shapeCls =
    shape === "square" ? "rounded-2xl" : shape === "blob" ? "rounded-blob" : "rounded-full";
  return (
    <span
      style={{ width: size, height: size, transform: `rotate(${rotate}deg)` }}
      className={`inline-flex items-center justify-center border-2 border-ink shadow-sticker-xs ${shapeCls} ${toneBg[tone]} ${
        wiggle ? "icon-wiggle" : ""
      } ${className}`}
      {...rest}
    >
      {Icon ? <Icon size={Math.round(size * 0.48)} strokeWidth={strokeWidth} /> : null}
    </span>
  );
};

export default FloatingIcon;
